import { useServer } from "../../server/ServerContext";
import { ConnectApplicationParams } from "./types";

/**
 * Connect a single application
 * @param applicationId application id
 * @returns mutate function
 */
export const useApplicationConnect = () => {
  const server = useServer();

  const mutate = (
    { applicationId, ...params }: ConnectApplicationParams,
    callback: (url: string) => any
  ) => {
    const uri = server.getUri({
      url: `applications/${applicationId}/connect`,
      params,
    });

    return callback(`${server.defaults.baseURL}/${uri}`);
  };

  return {
    mutate,
  };
};

export default useApplicationConnect;
